import React from 'react';

const Conformationmodal = ({show, onClose, onConfirm}) => {
   


  const handleCancel = (e) => {
    e.preventDefault();
    onClose();
  };

  if (!show) return null;

  return (
    <>
    <div className='modal-backdrop show' style={{
       backgroundColor: "rgba(255, 255, 255, 0.1)", 
       backdropFilter: "blur(20px) saturate(180%)",
       WebkitBackdropFilter: "blur(10px)",
    }}></div>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-header">
                <h5 className="modal-title text-bold fs-3">Delete Post</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label text-bold">Are you sure you want to delete this Post?</label>
                </div>
              </div>
              
              <div className="modal-footer d-flex justify-content-between ">   
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger"
                  onClick={onConfirm}
                >
                  Delete
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
      </>
  );
};

export default Conformationmodal;
